import { configureStore } from "@reduxjs/toolkit";
import toursReducer from "./slices/tourSlice";
import usersReducer from "./slices/userSlice";
import featuresReducer from "./slices/featuresSlice";
import requestsReducer from "./slices/tourRequestSlice";
import categoriesReducer from "./slices/categorySlice";
import blogReducer from "./slices/blogSlice";
import contactRequestsReducer from "./slices/contactSlice";

const store = configureStore({
  reducer: {
    tours: toursReducer,
    users:usersReducer,
    features:featuresReducer,
    requests:requestsReducer,
    categories: categoriesReducer,
    blogs:blogReducer,
    contacts:contactRequestsReducer
  },
});

export default store;